import { memo } from 'react';
import { Play, Pause } from 'react-feather';
import { cx } from '@trinity/chat-components/utils';
import styles from './style/Button.module.css';

type Props = {
  style?: React.CSSProperties;
  className?: string;
  playing: boolean;
  togglePlaying: () => void;
};

export const AudioPlayerButton = memo(({ className, style = {}, playing, togglePlaying }: Props) => {

  return (
    <div
      className={cx(styles.btn, className)}
      style={style}
      onClick={togglePlaying}>
      {playing
        ? <Pause style={{ fill: style?.fill }} className={styles.pause} />
        : <Play style={{ fill: style?.fill }} className={styles.play} />
      }
    </div>
  );
});

export default AudioPlayerButton;
